"use client";

import * as React from "react";

export function CircularProgress({
  value,
  size = 100,
  strokeWidth = 2,
  className = "",
}) {
  const [progress, setProgress] = React.useState(0);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  React.useEffect(() => {
    setProgress(value);
  }, [value]);

  return (
    <div
      className={`relative flex justify-center items-center w-${size} ${className}`}
    >
      <svg className="w-1/2 h-1/2" viewBox={`0 0 ${size} ${size}`}>
        <circle
          className="text-gray-300"
          strokeWidth={strokeWidth}
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className="text-[#EF761F]"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          stroke="currentColor"
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{
            transition: "stroke-dashoffset 0.5s ease 0s",
          }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-lg md:text-2xl font-semibold">
        {Math.round(progress)}%
      </div>
    </div>
  );
}

export function CircularProgressDemo() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setTimeout(() => setProgress(66), 500);
    return () => clearTimeout(timer);
  }, []);

  return <CircularProgress value={progress} className="mx-auto" />;
}
